module.exports = __webpack_public_path__ + "static/media/img_zero_basket.ebda91b5.svg";